import React from "react";

import ServiceIcon, { ServiceIconProps } from "./ServiceIcon";
import { PlainServiceIconWrapper } from "./ServiceIcon.style";

const PlainServiceIcon = (props: ServiceIconProps) => {
  return (
    <PlainServiceIconWrapper>
      <ServiceIcon {...props} />
    </PlainServiceIconWrapper>
  );
};

export default PlainServiceIcon;
